import { Reducer } from "redux";

import { UpdateNotificationViewListResponse } from "../models/api/Referral";
import { UpdateNotificationViewListDispatchTypes } from "../models/dispatchTypes/Referral";
import { UpdateNotificationViewListActionDispatchTypes } from "../constants/Referral";

const initialState: UpdateNotificationViewListResponse = {
  loading: false,
  response: false,
  error: null,
};

const PutNotificationViewListReducer: Reducer<
UpdateNotificationViewListResponse,
UpdateNotificationViewListDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UpdateNotificationViewListActionDispatchTypes.UPDATE_NOTIFICATION_VIEW_LIST_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UpdateNotificationViewListActionDispatchTypes.UPDATE_NOTIFICATION_VIEW_LIST_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UpdateNotificationViewListActionDispatchTypes.UPDATE_NOTIFICATION_VIEW_LIST_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case UpdateNotificationViewListActionDispatchTypes.UPDATE_NOTIFICATION_VIEW_LIST_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PutNotificationViewListReducer;
